<template>
  <section>
    <NewUserHeader></NewUserHeader>
    <div class="mx-28 w-1/3">
      <div class="mt-32 mb-10 flex text-5xl font-extrabold">Get in touch </div>
      <div class="text-lg text-gray-dark font-medium mb-4">Need help? We're here for you and your community.</div>
      <div class="text-lg text-gray-dark font-medium">We aim to respond to all questions as soon as possible. Please allow up to 24 hours for a response.</div>
      <div class="text-lg shadow-lg p-5 font-medium bg-white rounded-lg mt-16">
        <p class="font-bold">Email Us</p>
        <p>support@fitclass.com</p>
      </div>
    </div>
  </section>
</template>

<script>
import NewUserHeader from "@/components/layouts/Header/NewUserHeader.vue";
export default {
  components: {
    NewUserHeader,
  },
};
</script>
